import './Toast.scss';
import * as React from 'react';
import { add, clear, subscribe, IToastNotification } from './store';
import Icon from '../Icon';

const Toast = (props: IToastNotification) => {
  let icon = null;

  if (props.type === 'info') {
    icon = <Icon name="thumbs-up" className="ml-3" />;
  }

  if (props.type === 'error') {
    icon = <Icon name="alert-triangle" className="ml-3" />;
  }

  return (
    <div className={`Toast flex items-center ${props.type}`}>
      {props.message}
      {icon}
    </div>
  );
}

export const ToastContainer = () => {
  const [notifications, setNotifications] = React.useState<IToastNotification[]>([]);

  React.useEffect(
    () => subscribe((next) => setNotifications(next)),
    []
  );

  return (
    <div className="ToastContainer">
      {notifications.map((notification: IToastNotification) => (
        <Toast key={notification.id} {...notification} />
      ))}
    </div>
  );
};

export const addToast = add;
export const clearToasts = clear;



// WEBPACK FOOTER //
// ./src/components/Toast/index.tsx